import get from 'lodash.get';

import { createDeepEqualSelector } from '../../utils/selectors';

import { selectAuth } from '../selectors';

export const selectRequestPasswordReset = createDeepEqualSelector(selectAuth, (auth) => auth.requestPasswordReset);

export const selectLoading = createDeepEqualSelector(selectRequestPasswordReset, (requestPasswordReset) =>
  get(requestPasswordReset, 'loading', false),
);

export const selectError = createDeepEqualSelector(selectRequestPasswordReset, (requestPasswordReset) =>
  get(requestPasswordReset, 'err', false),
);

export const selectErrorMessage = createDeepEqualSelector(selectRequestPasswordReset, (requestPasswordReset) =>
  get(requestPasswordReset, 'errMsg', 'Error'),
);
